import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { selectDriverState, changeStatus, onSetSelectedDriver, onFetchDrivers, onFetchTotalRows } from "../redux/slices/driverSlice"
import { DriverAPI } from "../apis/DriverAPI"
import { driver } from "../types/slices/driverType"

export const useDriverStore = () => {

    const dispatch = useDispatch()
    const { drivers, driverSelected, status, action, totalRows } = useSelector(selectDriverState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getDrivers = async (data?: object) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await DriverAPI.getDrivers(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail, total } = response.data
            dispatch(onFetchDrivers(detail))
            dispatch(onFetchTotalRows(total || 0))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createDriver = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await DriverAPI.create(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const updateDriver = async (id: number, data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await DriverAPI.update(id, data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deleteDriver = async (id: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await DriverAPI.delete(id)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedDriver = (driver: driver) => {
        try {
            dispatch(onSetSelectedDriver(driver))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        //states
        drivers,
        driverSelected,
        status,
        action,
        totalRows,
        //actions
        getDrivers,
        setSelectedDriver,
        createDriver,
        updateDriver,
        deleteDriver
    }
}